import React, { useState, useEffect } from "react";

function BtcPriceDisplay() {
  const [btcPrice, setBtcPrice] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBtcPrice();
  }, []);

  const fetchBtcPrice = async () => {
    const apiUrl = 'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd';

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // CoinGecko API 返回的数据结构是 { bitcoin: { usd: price } }
      const price = data.bitcoin.usd;
      setBtcPrice(price);
      setError(null);
    } catch (e) {
      console.error("Failed to fetch BTC price from CoinGecko:", e);
      setError(e);
    }
  };

  return (
    <div>
      {error && <p className="error-message">Failed to load BTC price.</p>}
      {btcPrice !== null && (
        <p className="btc-price">
          Bitcoin Price: ${btcPrice.toFixed(2)}
        </p>
      )}
    </div>
  );
}

export default BtcPriceDisplay; 